/** Bounds for HTML date inputs — blocks 6+ digit years and absurd calendar jumps. */
export const DATE_INPUT_MIN = "1900-01-01";
export const DATE_INPUT_MAX = "2100-12-31";

const DATE_VALUE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Returns true when value is empty or a real YYYY-MM-DD date within [min, max].
 */
export function isValidDateInputValue(
	value,
	min = DATE_INPUT_MIN,
	max = DATE_INPUT_MAX
) {
	if (value == null || value === "") return true;
	if (typeof value !== "string") return false;
	const match = DATE_VALUE_RE.exec(value);
	if (!match) return false;

	const year = Number(match[1]);
	const month = Number(match[2]);
	const day = Number(match[3]);
	if (month < 1 || month > 12 || day < 1 || day > 31) return false;

	const parsed = new Date(Date.UTC(year, month - 1, day));
	if (
		parsed.getUTCFullYear() !== year ||
		parsed.getUTCMonth() !== month - 1 ||
		parsed.getUTCDate() !== day
	) {
		return false;
	}

	return value >= min && value <= max;
}

/**
 * Sanitize a date input onChange value. Returns "" for clear, the value when
 * valid, or null when the change should be rejected (keep previous).
 */
export function sanitizeDateInputChange(
	value,
	min = DATE_INPUT_MIN,
	max = DATE_INPUT_MAX
) {
	if (value == null || value === "") return "";
	return isValidDateInputValue(value, min, max) ? value : null;
}
